<div class="card">
  <div class="card-header">
    <i class="fa fa-book-open-reader"></i>Detalle de Solicitud de credito
    {{ this.creditRequest.code }}
    <div class="card-header-actions btn-group" dropdown placement="bottom left" *ngIf="showButtons">
      <!-- <button class="btn btn-sm btn-outline-success" type="button"><i class="fa fa-regular fa-floppy-disk"></i>&nbsp;Guardar Orden</button> -->
      <button class="btn btn-sm btn-outline-primary" type="button"
        [disabled]="this.creditRequest.processingStatus !== 'DRAFT'" (click)="handleCompleteRequestClick()">
        <i class="fa fa-pencil"></i>&nbsp;Completar
      </button>
      <button class="btn btn-sm btn-outline-success" type="button"
        [disabled]="this.getStatus(this.creditRequest) !== 'APPROVED'" (click)="handleInvoiceClick()">
        <i class="fa fa-regular fa-file"></i>&nbsp;Facturar
      </button>
      <button class="btn btn-sm btn-outline-primary" type="button"
        [disabled]="this.getStatus(this.creditRequest) !== 'APPROVED'" (click)="handlePreAnalisisClick()">
        <i class="fa fa-magnifying-glass-chart"></i>&nbsp;Pre-Analisis
      </button>

      <button class="btn btn-sm btn-outline-primary" type="button" (click)="handleDataChange()">
        <i class="fa fa-refresh"></i>&nbsp;Refrescar
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="alert alert-primary d-flex justify-content-between align-items-center" role="alert"
      *ngIf="this.creditRequest.processingStatus !== 'DRAFT'">
      <div>
        <h5 class="alert-heading">
          <i class="fa fa-regular fa-clock mr-2" aria-hidden="true"></i>Tiempo transcurrido
          desde la creación de la solicitud
        </h5>
        <p class="mb-1">
          Fecha Inicio de Solicitud:
          <b>{{
            this.creditRequestInitialDate | date : "dd-MM-yyyy, hh:mm:ss a"
            }}</b>
        </p>
        <p class="mb-1">
          Fecha Fin de Solicitud:
          <b>{{
            this.creditRequestEndDate | date : "dd-MM-yyyy, hh:mm:ss a"
            }}</b>
        </p>
      </div>
      <div>
        <app-pos-time-ago #timer></app-pos-time-ago>
      </div>
    </div>
    <accordion [isAnimated]="true">
      <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class="fa fa-users"></i> Información General
        </span>
        <div class="form-group row" *ngIf="
            this.creditRequest.requestData.codigoSolicitudAval != undefined &&
            this.creditRequest.requestData.codigoSolicitudAval !== ''
          ">
          <label class="col-md-3 col-form-label"><b>Solicitud Aval</b></label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" id="text-input" name="text-input" class="form-control" disabled
                [(ngModel)]="this.creditRequest.requestData.codigoSolicitudAval" />
              <span class="input-group-append">
                <button type="button" class="btn btn-outline-success" (click)="handleGoToClick(true)">
                  Ver Solicitud Aval
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group row" *ngIf="this.creditRequest.isAval === 'true'">
          <label class="col-md-3 col-form-label"><b>Solicitud Cliente</b></label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" id="text-input" name="text-input" class="form-control" disabled [(ngModel)]="
                  this.creditRequest.requestData.Codigo_Solicitud_Principal
                " />
              <span class="input-group-append">
                <button type="button" class="btn btn-outline-success" (click)="handleGoToClick(false)">
                  Ver Solicitud Cliente
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Fecha</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.creditRequest.createdDate" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Hora</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.creditRequest.createdHour" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>División</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.creditRequest.requestData.Division" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Empresa</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.creditRequest.requestData.Empresa" />
          </div>
        </div>
        <!-- <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Origen</b></label>
          <div class="col-md-9">
            <input
              type="text"
              id="text-input"
              name="text-input"
              class="form-control"
              disabled
              [(ngModel)]="this.creditRequest.origin"
            />
          </div>
        </div> -->
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Vendedor</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.creditRequest.seller.fullname" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-3 col-form-label" for="text-input"><b>Estado Onbase</b></label>
          <div class="col-md-9 text-left">
            <span [ngClass]="
                'badge large-font-size ' +
                getStatusClassByOnbaseStatus(this.getStatus(this.creditRequest))
              ">{{ this.creditRequest.parsedStatus }}</span>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-3 col-form-label" for="text-input"><b>Estado de Proceso</b></label>
          <div class="col-md-9 text-left">
            <span [ngClass]="
                'badge large-font-size ' +
                getStatusClassByOnbaseStatus(
                  this.creditRequest.processingStatus
                )
              ">{{
              this.getProcessingStatusMapValue(
              this.creditRequest.processingStatus
              )
              }}</span>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Comentario</b></label>
          <div class="col-md-9">
            <textarea type="text" id="text-input" name="text-input" class="form-control" disabled
              [value]="this.getParsedComments()">
            </textarea>
          </div>
        </div>
      </accordion-group>

      <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class="fa fa-regular fa-file-lines"></i> Información del Cliente
        </span>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Nombre</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.creditRequest.customer.fullName" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Código</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.creditRequest.customer.code" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Identificación</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled [(ngModel)]="
                this.creditRequest.customer.mainPersonalInfo.fiscalId
              " />
          </div>
        </div>
      </accordion-group>

      <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class="fa fa-regular fa-file-lines"></i> Información Plan de Crédito
        </span>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Plan de Crédito</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.creditRequest.requestData.Tramite" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Límite de Crédito</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.creditRequest.amount" />
          </div>
        </div>
      </accordion-group>

      <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class="fa fa-regular fa-file-lines"></i> Requerimientos
        </span>
        <div class="alert alert-success d-flex justify-content-between align-items-center" role="alert"
          *ngIf="this.creditRequest.processingStatus !== 'DRAFT'">
          <div>
            <h5 class="alert-heading">
              <i class="fa fa-regular fa-clock mr-2" aria-hidden="true"></i>Tiempo
              transcurrido desde la creación de los requerimientos
            </h5>
            <p class="mb-1">
              Primer Requerimiento Recibido:
              <b>{{
                this.firstRequirementDate | date : "dd-MM-yyyy, hh:mm:ss a"
                }}</b>
            </p>
            <p class="mb-1">
              Último requerimiento confirmado:
              <b>{{
                this.lastRequirementCompletedDate
                | date : "dd-MM-yyyy, hh:mm:ss a"
                }}</b>
            </p>
          </div>
          <div>
            <app-pos-time-ago #requirementsTimer></app-pos-time-ago>
          </div>
        </div>
        <pos-table tableFormId="requirementsTable" [data]="requirements" [headers]="getRequirementsTableHeaders()"
          [itemsPerPage]="10" [pagination]="false" [disableHighlight]="true" [badgeSuccessValues]="['Completado']"
          [badgeWarningValues]="['Pendiente']" [showRefreshButton]="true" (dataChange)="handleDataChange()">
        </pos-table>
      </accordion-group>
    </accordion>
  </div>
</div>